const findAnnouncements = ({ announcements }, { category }) => announcements[category];

export default findAnnouncements;
